import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SearchNotificationService {
  constructor(private http: HttpClient) {}

  // User vacant vehicle search history
  getUserSearchHistory(data: any) {
    return this.http.get(
      environment.apiUrl +
        `admin/user/search-history?page=${data.page}&limit=${data.limit}`,
    );
  }

  // Driver load search history
  getDriverSearchHistory(data: any) {
    return this.http.get(
      environment.apiUrl +
        `admin/driver/search-history?page=${data.page}&limit=${data.limit}`,
    );
  }

  // Get user search history by ID
  getUserSearchHistoryById(id: any) {
    return this.http.get(
      environment.apiUrl + `admin/user/search-history/${id}`,
    );
  }

  // Get driver search history by ID
  getDriverSearchHistoryById(id: any) {
    return this.http.get(
      environment.apiUrl + `admin/driver/search-history/${id}`,
    );
  }
}
